angular.module('unica_partner.partner_controllers')

.controller('PartnerCreateController', function(
	$rootScope, $scope, $state,
	PartnerCreateService
) {

	$scope.pageTitle = 'Aggiungi Partner';

	$scope.partnerData = {
		fullname: '',
		bio: '',
		avatar: ''
	};

	$scope.savePartner = function() {
		$scope.showLoader();

		if ( typeof $scope.partnerData.avatar !== "undefined" ) {
			$scope.partnerData.avatar = $scope.partnerData.avatar.dataURL;
		} else {
			$scope.partnerData.avatar = '';
		}

		var partnerData = angular.copy($scope.partnerData);

		PartnerCreateService
			.create(partnerData)
			.then(function(data) {
				$scope.hideLoader();
				if (!data.error) {
					$scope.showSuccessMsg('Partner aggiunto con successo!', '');
					// $rootScope.partnerData = {};
					$state.go('app.partner.list');
				} else {
					$rootScope.manageError(data);
				}
			});

	};

})

;
